// MUST STAY FIRST. Side-effecting: it patches XMLHttpRequest, which Angular's
// HttpClient resolves at request time, and installs the tracer that creates the
// trace id every API call carries. An editor's "organize imports" will sort
// this below @angular/core, and the only symptom is that no backend ever sees a
// traceparent -- nothing is logged and nothing fails (CORE-142).
import './otel'
import {enableProdMode} from '@angular/core'
import {environment} from './environments/environment'
import {AppComponent} from './app/app.component'
import {bootstrapApplication} from '@angular/platform-browser'
import {appConfig} from './app/app.config'

if (environment.production) {
    enableProdMode()
}

bootstrapApplication(AppComponent, appConfig)
    .catch(err => console.error(err))
